import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import '../../index.scss';
import PlanningView from './index';
import { GlobalToast } from 'components/GlobalToast';
var PlanningViewContainer = function () { return (_jsxs(_Fragment, { children: [_jsx(PlanningView, {}), _jsx(GlobalToast, {})] })); };
export default PlanningViewContainer;
